// src/data/storiesProgressRepo.js
/**
 * Firestore Repo Layer
 * --------------------
 * Components should NOT import firebase/firestore directly.
 * All Firestore reads/writes live in small "repo" modules in /data so we can
 * later swap the implementation (Web SDK today, Native SDK later) without
 * touching UI components.
 */

import { collection, getCountFromServer, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Count finished stories for a user in a specific language.
 * Collection path: users/{uid}/storyProgress_{language}
 */
export async function countFinishedStories({ uid, language }) {
  if (!uid) throw new Error("countFinishedStories: uid is required");
  if (!language) throw new Error("countFinishedStories: language is required");

  const colRef = collection(db, "users", uid, `storyProgress_${language}`);
  const q = query(colRef, where("status", "==", "finished"));

  // Prefer server-side aggregate count (cheaper than downloading docs)
  try {
    const agg = await getCountFromServer(q);
    return agg.data().count;
  } catch (e) {
    // Fallback: download matching docs and count locally
    const snap = await getDocs(q);
    return snap.size;
  }
}